import React, { useState, useEffect } from 'react';
import './buynow.css';
import { Divider } from '@mui/material';
import { useCart, useDispatchCart } from '../contextreducer/ContextReducer';
import CircularProgress from '@mui/material/CircularProgress';
import AddresForm from './AddresForm';
import Modal from '../Modol';
import AddIcon from '@mui/icons-material/Add';
import { NavLink, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../helper';
// import Order from './Order';

export default function Checkout() {

  const data = useCart(); // Get the state from the context
  const dispatch = useDispatchCart()
  const totalPrice = data[0].totalPrice;

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  // const [totalPrice, setTotalPrice] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [isPaymentMethodSelected, setIsPaymentMethodSelected] = useState(false);
  const [getdata, setgetdata] = useState([]);
  const [CartView, setCartView] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState('');
  const [isAddressSelect, setisAddressSelect] = useState(false);
  const [btnView, setbtnView] = useState(false);
  const [getaddressdataId, setgetaddressdataId] = useState('');

  const delivery = 50;

  useEffect(() => {
    const fetchData = async () => {
      try {
        let userEmail = localStorage.getItem("userEmail");
        const response = await fetch(`${BASE_URL}/api/getaddress?email=${userEmail}`);
        const jsonData = await response.json();
        setgetdata(jsonData);
        console.log(jsonData);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  const Update = (dataId) => {
    setSelectedAddressId(dataId);
    setCartView(true);
  };

  const handleCloseModal = () => {
    setSelectedAddressId('');
    setCartView(false);
  };

  const handlePaymentMethodChange = (e) => {
    setPaymentMethod(e.target.value);
  };

  const handleUsePaymentMethod = () => {
    // Perform actions based on the selected payment method
    console.log(paymentMethod);
    setIsPaymentMethodSelected(true);
  };

  const getaddressId = (dataId) => {
    setbtnView(true);
    setgetaddressdataId(dataId);
    console.log(dataId);
  };

  const handleAddressUse = () => {
    setisAddressSelect(true);
  };

  const handleProceedtoBuy = () => {
    console.log(getaddressdataId);
    dispatch({ type: 'SET_ADDRESSID', addressId: getaddressdataId });
    navigate('/confirm-order');
  };


  if (isLoading) {
    return (
      <div className="cart_section">
        <div className="circle">
          <CircularProgress />
          <h2>Loading....</h2>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="buynow_section">
        <div className="buynow_container">
          <div className="left_buy">
            <div>
              <h2>Your addresses</h2>
            </div>
            <Divider />
            {getdata.length > 0 ? (
              getdata.map((data) => (
                <div className="display_data" key={data._id}>
                  <input
                    type="radio"
                    id={data._id}
                    name="selectaddress"
                    onClick={() => getaddressId(data._id)}
                    disabled={isAddressSelect}
                  />
                  <label htmlFor={data._id}>
                    <strong>{data.fname},</strong>
                    <br />
                    {data.address} {data.area},
                    <br />
                    {data.city}, {data.state}, {data.pincode},
                    <br />
                    phone number: {data.mobile}
                  </label>
                  <br />
                  {!isAddressSelect && (
                    <span onClick={() => Update(data._id)}>
                      <NavLink>Edit address</NavLink>
                    </span>
                  )}
                </div>
              ))
            ) : (
              <h4>No addresses found.</h4>
            )}

            {btnView ? (
              <button
                className={`place_oder_btn m-0 ${isAddressSelect ? 'disabled' : ''
                  }`}
                onClick={() => handleAddressUse()}
                disabled={isAddressSelect}
              >
                use this address
              </button>
            ) : null}

            <button
              className={`place_oder_btn ${isAddressSelect ? 'disabled' : ''}`}
              onClick={() => {
                setCartView(true);
              }}
              disabled={isAddressSelect}
            >
              <AddIcon id="add-icon" />
              Add new address
            </button>

            {CartView && (
              <Modal onClose={handleCloseModal}>
                <AddresForm selectedAddressId={selectedAddressId} />
              </Modal>
            )}
            <div className="mt-2">
              <h2>Select a payment method</h2>
            </div>
            <Divider />
            <div className="payment_methods">
              <div className="payment_method">
                <input
                  type="radio"
                  id="cards"
                  name="paymentMethod"
                  value="cards"
                  checked={paymentMethod === 'cards'}
                  onChange={handlePaymentMethodChange}
                  disabled={isPaymentMethodSelected}
                />
                <label htmlFor="cards">Pay with Debit/Credit/ATM Cards</label>
                <p>You can save your cards as per new RBI guidelines. Learn More</p>
              </div>
              <div className="payment_method">
                <input
                  type="radio"
                  id="netbanking"
                  name="paymentMethod"
                  value="netbanking"
                  checked={paymentMethod === 'netbanking'}
                  onChange={handlePaymentMethodChange}
                  disabled={isPaymentMethodSelected}
                />
                <label htmlFor="netbanking">Net Banking</label>
              </div>
              <div className="payment_method">
                <input
                  type="radio"
                  id="upi"
                  name="paymentMethod"
                  value="upi"
                  checked={paymentMethod === 'upi'}
                  onChange={handlePaymentMethodChange}
                  disabled={isPaymentMethodSelected}
                />
                <label htmlFor="upi">Other UPI Apps</label>
              </div>
              <div className="payment_method">
                <input
                  type="radio"
                  id="emi"
                  name="paymentMethod"
                  value="emi"
                  checked={paymentMethod === 'emi'}
                  onChange={handlePaymentMethodChange}
                  disabled={isPaymentMethodSelected}
                />
                <label htmlFor="emi">EMI</label>
              </div>
              <div className="payment_method">
                <input
                  type="radio"
                  id="cod"
                  name="paymentMethod"
                  value="cod"
                  checked={paymentMethod === 'cod'}
                  onChange={handlePaymentMethodChange}
                  disabled={isPaymentMethodSelected}
                />
                <label htmlFor="cod">Cash on Delivery/Pay on Delivery</label>
              </div>
              <div className="payment_method">
                <input
                  type="radio"
                  id="scanpay"
                  name="paymentMethod"
                  value="scanpay"
                  checked={paymentMethod === 'scanpay'}
                  onChange={handlePaymentMethodChange}
                  disabled={isPaymentMethodSelected}
                />
                <label htmlFor="scanpay">
                  Scan & Pay using Amazon app. Cash, UPI, Cards also accepted. Know more.
                </label>
              </div>
            </div>
            <button
              className={`place_oder_btn m-0 ${isPaymentMethodSelected ? 'disabled' : ''
                }`}
              type="button"
              onClick={handleUsePaymentMethod}
              disabled={isPaymentMethodSelected}
            >
              Use this payment method
            </button>
          </div>
          <div className="right_buy">
            <img
              src="https://images-eu.ssl-images-amazon.com/images/G/31/checkout/assets/TM_desktop._CB443006202_.png"
              alt="rightimg"
            />
            <div className="cost_right">
              <p>
                Your order is eligible for FREE Delivery.
                <br />
                <span style={{ color: '#565959' }}> Select this option at checkout. Details</span>
              </p>
              <Divider />
              <h5 className="pt-1">Order Summary</h5>
              <table className="data-table">
                <tbody>
                  <tr className="order-summary">
                    <td className="table-data">Items:</td>
                    <td className="table-data">₹{totalPrice}</td>
                  </tr>
                  <tr className="order-summary">
                    <td className="table-data">Delivery:</td>
                    <td className="table-data">₹{delivery}</td>
                  </tr>
                  <tr className="order-summary">
                    <td className="table-data">Total:</td>
                    <td className="table-data">₹{totalPrice + delivery}</td>
                  </tr>
                </tbody>
              </table>
              <div className="order_total">
                <h5>
                  Order Total ({data.length} item):{' '}
                  <span style={{ fontWeight: '500', paddingLeft: '7px' }}>₹{totalPrice + delivery}</span>
                </h5>
              </div>
              <button
                className={`rightbuy_btn ${!isPaymentMethodSelected ? 'disabled' : ''}`}
                disabled={!isPaymentMethodSelected}
                onClick={handleProceedtoBuy}
              >
                Proceed to Buy
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
